<template>
  <div>
    <div class="uNY2u87Ih6yCf2fiwE1Q">
      <div class="tabsWarp">
        <div
          v-for="(item, index) in popList"
          :class="{
            'common-tab-item-active': tabIndex == index
          }"
          @click="tabIndex = index"
          class="common-tab-item"
          style="display: flex"
        >
          <svg-icon
            className="imageWrap_s"
            style="width: 0.28rem; height: 0.28rem"
            v-if="item.content"
            icon-class="icon_message_tz--svgSprite:all"
          />
          <svg-icon
            className="imageWrap_s"
            v-if="!item.content"
            style="width: 0.28rem; height: 0.28rem"
            icon-class="icon_message_pmd--svgSprite:all"
          />
          <p class="DrmJS14Na6dEK53vAAQX">{{ item.title }}</p>
        </div>
      </div>
      <div class="common-tabs-content">
        <div
          v-if="tabIndex"
          @click="tabIndex = tabIndex - 1"
          class="_fhJToJ9pBZeoyjqe5a7 Zl2ywfksX9ooF1aQ02T9"
        >
          <svg-icon
            className="imageWrap_s"
            style="width: 0.22rem; height: 0.22rem"
            icon-class="comm_icon_fh--svgSprite:all"
          />
        </div>

        <div
          v-if="tabIndex != popList.length - 1"
          @click="tabIndex = tabIndex + 1"
          class="mHrSCgmC4tq6FJbB8Ak3 Zl2ywfksX9ooF1aQ02T9"
          style="transform: rotate(180deg)"
        >
          <svg-icon
            className="imageWrap_s"
            style="width: 0.22rem; height: 0.22rem"
            icon-class="comm_icon_fh--svgSprite:all"
          />
        </div>

        <div
          style="overflow: auto; height: 100%"
          v-if="popList[tabIndex]"
          @click="openUrl(popList[tabIndex])"
        >
          <div v-if="popList[tabIndex].content">
            <div class="vinlOtU5EHTmNDU9ECDE">
              {{ popList[tabIndex].title }}
            </div>
            <p v-html="popList[tabIndex].content"></p>
          </div>
          <div v-else>
            <img
              class="common-tabs-img"
              v-lazy="popList[tabIndex].image"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
    <div class="w17XHHAxCcKClzGm6mQu">
      <div class="WTY15hpGrP99ziiNSdSp">
        <van-checkbox
          v-model="typeInit2"
          @change="vanCheckbox"
          shape="square"
          checked-color="var(--theme-secondary-color-success)"
          icon-size=".32rem"
        >
          <span
            class="chen_texbt"
            :style="{
              color: '#fff'
            }"
            >{{ $t('components._hojeNovamente') }}</span
          >
        </van-checkbox>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { userInfo } from '@/apis/modules/home.js';
export default {
  props: {
    popList: {
      type: [Object, Array],
      required: []
    }
  },
  data() {
    return {
      codeValue: '',
      inputFocus: false,
      typeInit2: false,
      tabIndex: 0,
      rememberPassword: window.localStorage.getItem('rememberPassword')
    };
  },
  computed: {
    ...mapState(['vuex_token_head','userInfo'])
  },
  mounted() {
    this.getUserInfo();
  },
  methods: {
    getUserInfo() {
      if(this.$store.state.config.goto_bind_ws && this.userInfo.id && !this.userInfo.bind_ws && this.$store.state.config.bind_ws){
        userInfo({}).then(({ data,code }) => {
          if(code == 0){
            this.$store.state.config.goto_bind_ws = false;
            this.$store.commit('userInfo', data);
          }
        });
      }
    },
    vanCheckbox(e) {
      this.$emit('vanCheckbox', e);
    },
    openUrl(e) {
      if (e.jump_url && e.jump_url != '#') {
        if (/^http/.test(e.jump_url)) {
          window.open(e.jump_url, '_blank');
          return false;
        }
        if (e.jump_url == 'dailySignIn') {
          this.$store.commit('publicFun', ['CancelIsSigned_days', true]);
          return false;
        }
        if (e.jump_url == 'pdd') {
          this.$store.state.isShowWheelSpinEvent = true;
          return false;
        }else if (e.jump_url == 'recharge') { 
          if (!this.vuex_token_head) {
            if (this.rememberPassword && this.rememberPassword.length) {
              this.$store.commit('isRecord');
              this.$store.commit('publicFun', ['isRecordType', 1]);
            } else {
              this.$store.commit('isRecord');
              this.$store.commit('publicFun', ['isRecordType', 0]);
            }
            return false;
          }
          this.$store.commit('isDeposit', true);
          return false;
        }else if (e.jump_url == '#register') {
          if (!this.vuex_token_head) {
            if (this.rememberPassword && this.rememberPassword.length) {
              this.$store.commit('isRecord');
              this.$store.commit('publicFun', ['isRecordType', 1]);
            } else {
              this.$store.commit('isRecord');
              this.$store.commit('publicFun', ['isRecordType', 0]);
            }
            return false;
          }
          return false;
        }else if (e.jump_url == '#BINDWS#') {
          let uid = '';
          if (this.vuex_token_head) {
            // 判断是否已经绑定
            if(this.userInfo.bind_ws)return false;
            uid = this.userInfo.id
          }
          this.$store.state.config.goto_bind_ws = true;
          this.$router.push({
            name: 'webviewCommon',
            params: {
              url: this.$store.state.config.bind_ws+'?p='+window.location.hostname+'&u='+uid
            }
          });
          return false;
        }
        this.$router.push({ name: e.jump_url });
      }
      // if(e.jump_url && e.jump_url!='#'){
      // 	this.$router.push({name:e.jump_url})
      // }
    }
  }
};
</script>
<style>
.login-body {
  font-weight: 400;
}
.van-popup.advertisement_-conter {
  background-color: transparent;
}
.w17XHHAxCcKClzGm6mQu .van-checkbox__icon .van-icon {
  border-radius: 0.06rem;
}
</style>
<style scoped>
.w17XHHAxCcKClzGm6mQu {
  -ms-flex-align: center;
  -ms-flex-pack: center;
  align-items: center;
  display: -ms-flexbox;
  display: flex;
  justify-content: center;
  margin-top: 0.2rem;
  width: 100%;
}

.WTY15hpGrP99ziiNSdSp {
  -ms-flex-align: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 0.1rem;
  bottom: 0.34rem;
  color: #fff;
  display: -ms-flexbox;
  color: #fff;
  display: flex;
  font-size: 0.18rem;
  left: 50%;
  font-size: 0.22rem;
  padding: 0.1rem 0.15rem 0.1rem 0.1rem;
}
.Zl2ywfksX9ooF1aQ02T9 {
  font-size: 0.22rem;
  height: 0.44rem;
  width: 0.44rem;
}
._fhJToJ9pBZeoyjqe5a7 {
  left: 0.08rem;
}
.mHrSCgmC4tq6FJbB8Ak3 {
  right: 0.08rem;
}
.Zl2ywfksX9ooF1aQ02T9 {
  -ms-flex-line-pack: center;
  -ms-flex-pack: center;
  align-content: center;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 50%;
  color: #fff;
  cursor: pointer;
  display: -ms-flexbox;
  display: flex;
  align-items: center;
  font-size: 0.18rem;
  height: 0.36rem;
  justify-content: center;
  position: absolute;
  top: 48%;
  width: 0.36rem;
  z-index: 1;
}
.vinlOtU5EHTmNDU9ECDE {
  max-width: 90%;
  line-height: 1.38;
  margin: 0 auto 0.2rem;
  font-size: 0.3rem;
  color: var(--theme-text-color-darken);
  text-align: center;
}
.common-tab-item-active {
  background-color: rgba(var(--theme-primay-color-hex), 0.05);
}
.uNY2u87Ih6yCf2fiwE1Q {
  height: 4.2rem;
  display: flex;
  border: 0.01rem solid var(--theme-color-line);
  border-radius: 0.2rem;
  background-color: var(--theme-main-bg-color);
  position: relative;
}
.common-tab-item {
  display: flex;
  align-items: center;
  height: 0.8rem !important;
  box-sizing: border-box;
  padding: 0.1rem 0.15rem;
  text-align: revert !important;
}
.common-tab-item .imageWrap_s {
  color: var(--theme-text-color-lighten);
  margin-right: 0.08rem;
}
.DrmJS14Na6dEK53vAAQX {
  color: var(--theme-primary-color);
  flex: 1;
  font-size: 0.22rem;
  line-height: 0.28rem;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  font-size: 0.22rem;
  line-height: 0.22rem;
  overflow: hidden;
  white-space: break-spaces !important;
}
.common-tabs-content {
  width: 5.28rem;
  font-size: 0.23rem;
  line-height: 1.64;
  box-sizing: border-box;
  padding: 0.2rem;

  position: relative;
  text-align: left;
}
.common-tabs-img {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
.tabsWarp {
  border-right: thin solid var(--theme-color-line);
  width: 1.62rem;
}
.advertisement_list {
  width: 6.9rem;
  background-color: var(--theme-main-bg-color);
  border-radius: 0.2rem;
}
.advertisement_list .title {
  color: var(--theme-text-color-darken);
  text-align: center;
  line-height: 1rem;
  font-size: 0.4rem;
}
._common-tabs-content {
  max-height: 5.4rem;
  width: 100%;
}
.consliTst {
  display: flex;
  align-items: center;
  border-radius: 0.1rem;
  height: 0.8rem !important;
  background-color: rgba(var(--theme-primay-color-hex), 0.05);
  max-width: 2.05rem;
  padding: 0.15rem;
  text-align: revert !important;
}
.consliTst svg {
  width: 0.38rem;
  height: 0.38rem;
  color: var(--theme-primary-color);
  margin-right: 0.08rem;
}
.consliTst span {
  font-size: 0.22rem;
  display: inline-block;
  line-height: 0.28rem;
  flex: 1;
  color: var(--theme-primary-color);
  overflow: hidden;
  text-overflow: ellipsis;
  /* white-space: nowrap; */
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  white-space: break-spaces !important;
}
</style>
